<template>
  <!-- TODO: 支持转人工，人工接待 -->
  <div class="app">
    <splitpanes class="default-theme">
      <pane size="30">
        <bd-aside></bd-aside>
      </pane>
      <pane size="53">
        <splitpanes horizontal>
          <pane size="8" min-size="6">
            <bd-top></bd-top>
          </pane>
          <pane size="79">
            <bd-message></bd-message>
          </pane>
          <pane size="23" min-size="15">
            <bd-input></bd-input>
          </pane>
        </splitpanes>
      </pane>
      <pane size="35">
        <!-- <bd-right></bd-right> -->
      </pane>
    </splitpanes>
  </div>
</template>

<script>
// https://antoniandre.github.io/splitpanes/
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import BdAside from '@/components/dashboard/main/monitor/threadRobot/BdAside'
// import BdMain from '@/components/dashboard/main/monitor/BdMain'
// import BdTop from '@/components/dashboard/main/monitor/threadRobot/BdTop'
// import BdMessage from '@/components/dashboard/main/monitor/threadRobot/BdMessage'
// import BdInput from '@/components/dashboard/main/monitor/threadRobot/BdInput'
// import BdRight from '@/components/dashboard/main/monitor/threadRobot/BdRight'
import BdTop from '@/components/dashboard/main/chat/middle/BdTop'
import BdMessage from '@/components/dashboard/main/chat/middle/BdMessage'
import BdInput from '@/components/dashboard/main/chat/middle/BdInput'

export default {
  name: 'bd-online',
  // components: { BdAside, BdMain, Layout }, BdRight, 
  components: { BdAside, BdTop, BdMessage, BdInput, Splitpanes, Pane },
  data () {
    return {
      // resize: true,
      // splits: {
      //   dir: 'horizontal',
      //   first: 0,
      //   second: 1,
      //   split: '20%'
      // }
    }
  }
}
</script>

<style scope>
</style>
